import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgShowroom = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("g", {
		clipPath: "url(#clip0_2517_10526)",
		children: /* @__PURE__ */ _jsx("g", {
			clipPath: "url(#clip1_2517_10526)",
			children: /* @__PURE__ */ _jsx("path", {
				d: "M22 2H2V22L6 18H22V2ZM5 14L8.5 9.5L11 12.51L14.5 8L19 14H5Z",
				fill: "currentcolor"
			})
		})
	}), /* @__PURE__ */ _jsxs("defs", { children: [/* @__PURE__ */ _jsx("clipPath", {
		id: "clip0_2517_10526",
		children: /* @__PURE__ */ _jsx("rect", {
			width: 24,
			height: 24,
			fill: "white"
		})
	}), /* @__PURE__ */ _jsx("clipPath", {
		id: "clip1_2517_10526",
		children: /* @__PURE__ */ _jsx("rect", {
			width: 24,
			height: 24,
			fill: "white"
		})
	})] })]
});
export default SvgShowroom;
